import Background from "./Background";
import Footer from "./Footer";
import "./Contact.css";
import { useAuthContext } from "../firebase/AuthContext";
import { Link } from "react-router-dom";

function Contact() {
  const { userLanguage } = useAuthContext();

  const texts = {
    en: {
      content: "Do you have any questions or want to give feedback?",
      contactUs: "Contact us:",
    },
    de: {
      content: "Hast du Fragen oder möchtest Feedback geben?",
      contactUs: "Kontaktiere uns:",
    },
  };

  return (
    <>
      <Background />
      <Footer />
      <div className="contact">
        <div className="content">
          <p>{texts[userLanguage]["content"]} </p>
          <span>
            {texts[userLanguage]["contactUs"]}
            {"  "}
            <Link className="link" to="mailto:support@gliatech.net">
              support@gliatech.net
            </Link>
          </span>
        </div>
      </div>
    </>
  );
}

export default Contact;
